'use client';
import { revalidatePage } from '@/actions/server.actions';
import useEditProfileStore from '@/components/store/editProfileModalSlice';
import { Disclosure } from '@headlessui/react';
import Button from '@ui/Button';
import Chip from '@ui/Chip';
import FadeTransition from '@ui/Transitions/FadeTransition';
import Typography from '@ui/Typography';
import Image from 'next/image';
import React from 'react';
import { HiOutlinePlusCircle } from 'react-icons/hi';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import useUserCausesStore from './store';

function CausesList(props) {
  const { title, causes, expanded = false, user } = props;

  const setShowEditor = useUserCausesStore((state) => state.setShowEditor);
  const setIsOpen = useEditProfileStore((state) => state.setOpen);

  const handleEdit = () => {
    setShowEditor(true, causes);
    setIsOpen(true, user, 'Causes Supported');
    // revalidatePage('/home');
  };

  return (
    <Disclosure defaultOpen={expanded}>
      {({ open }) => (
        <>
          <Disclosure.Button className="flex w-full items-center justify-between">
            <div className="flex items-center justify-start gap-4">
              <Image
                width={40}
                height={40}
                src="/assets/icons/causes.svg"
                alt="causes"
                className="h-10 w-10"
              />
              <Typography variant="h3" className="text-left">
                {title}
              </Typography>
            </div>
            <MdOutlineKeyboardArrowDown
              className={`${
                open ? 'rotate-180 transform' : ''
              } h-5 w-5 text-text-secondary`}
            />
          </Disclosure.Button>
          <FadeTransition>
            <Disclosure.Panel className="mt-6 flex flex-wrap items-center justify-start gap-4">
              {causes.length === 0 && (
                <div className="flex flex-1 items-center justify-start">
                  <Typography variant="h4" color="textDisabled">
                    No causes added yet
                  </Typography>
                </div>
              )}

              {causes.map((cause) => (
                <Chip key={cause.id} color="secondary" text="small">
                  {cause.cause_title}
                </Chip>
              ))}

              <Button variant="icon" className="!p-0" onClick={handleEdit}>
                <HiOutlinePlusCircle className="h-9 w-9 text-chips-secondary" />
              </Button>
            </Disclosure.Panel>
          </FadeTransition>
        </>
      )}
    </Disclosure>
  );
}

export default CausesList;
